// removed by extract-text-webpack-plugin
module.exports = {"aboutTab":"b9GfUz25_dYZTDNqxmfn","isDisabled":"_1UdRCX_hlOvn5dzIT8cDSi","isActive":"_31VI90WJVknHAl4qWoPXf4","tooltip":"_1zwk-UJjuLTYi8NX5jo9K2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutTab/AboutTab.css
// module id = 168
// module chunks = 0